import React from "react";

import { CheckboxSelectProps, CheckboxSelectBehavior } from "./types";
import { SelectButton } from "./components/Button";
import { useCheckboxSelect, useOpenState } from "./hooks";
import { InnerSection } from "./components/InnerSection";

const CheckboxSelect = ({
  config,
  options,
  selectedItems,
  setSelectedItems,
  defaultSelected,
  title,
  dataTestId,
  disabled,
  checkboxBehavior,
  checkboxSelectStyle,
  className,
}: CheckboxSelectProps) => {
  const hasCategory = !Object.keys(options?.[0] || {})?.includes("value");
  const { open, setOpen, ref } = useOpenState(config.openSetter ?? (() => {}));
  const {
    checkedItems,
    allChecked,
    handleCheck,
    handleClearAll,
    handleSelectVarious,
    handleUncheck,
    initialChecked,
  } = useCheckboxSelect({
    type: checkboxBehavior as CheckboxSelectBehavior,
    setSelectedItems,
    selectedItems,
    defaultSelected,
    applyOnClose: config.applyOnClose,
    withCategory: hasCategory,
    options,
    hideApply: config.hideApply,
    open,
  });
  return (
    <div
      className={`flex flex-col relative ${className}`}
      data-testid={dataTestId}
      key={config.itemKey}
      ref={ref}
    >
      <SelectButton
        title={title}
        setOpen={setOpen}
        dataTestId={dataTestId ?? ""}
        width={config.buttonStyle.width ?? 0}
        height={config.buttonStyle.height}
        style={checkboxSelectStyle ?? "regular"}
        selectedItems={selectedItems}
        disabled={disabled ?? false}
        className={className ?? ""}
      />

      {open && (
        <InnerSection
          open={open}
          boxWidth={config.boxWidth ?? ""}
          options={options}
          optionsName={config.labels?.optionsName ?? ""}
          searchThreshold={config.searchThreshold ?? 0}
          type={checkboxBehavior as CheckboxSelectBehavior}
          withCategory={hasCategory}
          buttonType={
            (config.buttonType ?? "primary") as "primary" | "secondary"
          }
          onDeleteFilter={config.onDeleteFilter ?? (() => {})}
          defaultSelected={defaultSelected ?? []}
          hideApply={config.hideApply ?? false}
          handleClearAll={handleClearAll}
          handleSelectVarious={handleSelectVarious}
          secondaryButtonText={config.labels?.secondaryButtonText ?? ""}
          setOpen={setOpen}
          setSelectedItems={setSelectedItems}
          applyCallback={config.applyCallback ?? (() => {})}
          checkedItems={checkedItems}
          allChecked={allChecked}
          handleCheck={handleCheck}
          handleUncheck={handleUncheck}
          initialChecked={initialChecked}
        />
      )}
    </div>
  );
};

export default CheckboxSelect;
